<main class="app_template_c__container" id="templateContainer">
	<app-print-header></app-print-header>
	<p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
		<ng-template pTemplate="header">
			<label><strong>Esops de exposición: </strong>
				{{ examen.esops?.length }}</label>
		</ng-template>
		<p-scrollPanel [style]="{ height: '200px' }">
			<p-table [value]="examen.esops">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 20%; text-align: center;">Código</th>
						<th style="width: 80%; text-align: center;">Concepto</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td style="text-align: center;">{{ item.codigo }}</td>
						<td style="text-align: center;">{{ item.descripcion }}</td>
					</tr>
				</ng-template>
			</p-table>
		</p-scrollPanel>
		<p-footer>
			<p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
		</p-footer>
	</p-dialog>


	<form (ngSubmit)="onSubmit()" *ngIf="examForm" [formGroup]="examForm" id="idFormLogin" name="formLogin">
		<div class="form-container p-fluid">


			<div class="p-grid p-jc-between" style="margin-bottom: 15px;">
				<div class="" style="display: flex;">
					<span>
						<i (click)="goBack()" class="pi pi-arrow-left"
							style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
					</span>
					<label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
				</div>

				<span class="print_hide-on-print">
					<app-print-button></app-print-button>
				</span>
			</div>

			<div class="p-grid">
				<div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
					<app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
					<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						{{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
					</span>

					<p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date"
						dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init"
						[maxDate]="maxDate" [minDate]="minDate" class="print_hide-on-print"
						[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
						[disabled]="examen?.modoVista === 'ver'">
					</p-calendar>

					<app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid">
					</app-invalid-from-message>
				</div>


				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Lote"></app-fiel-title>
					<p class="readOnly">
						{{examen.lote.numeroLote}}
					</p>
				</div>


				<div class="p-field p-col-12 p-md-2">
					<app-fiel-title label="Nro. Carpeta"></app-fiel-title>
					<p class="readOnly">
						{{examen.numeroCarpeta}}
					</p>
				</div>

				<div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
					<label class="color-text" (click)="displayAgentes = true">
						Esops de exposición ({{ examen.esops?.length }})</label>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Empleador')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Empleador") }}. Datos de la empresa
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid">
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Razón Social"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIT"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Establecimiento"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Teléfono"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Dirección de E-mail"></app-fiel-title>
						<p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Trabajador')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Trabajador") }}. Datos Del Trabajador
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div class="p-field p-col-12 p-md-4 print_row-full">
						<app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
						  formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
						  [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.apellidoNombre.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
						<app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
											message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
										</app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="CUIL"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.cuil}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
						  {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
						  placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
						  [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
						  (onSelect)="calculateAge()" (onBlur)="calculateAge()"
						  [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
					  </div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="DNI"></app-fiel-title>
						<p class="readOnly">
							{{examen.trabajador.numeroDocumento}}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Sexo"></app-fiel-title>
						<p class="readOnly">
							{{ getDescripcionSexo() }}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 print_row-full p_hidden">
						<app-fiel-title label="Domicilio"></app-fiel-title>
						<p class="readOnly">
							{{ examen.trabajador.calle }} {{ examen.trabajador.numeroCalle }}
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4 p_hidden">
						<app-fiel-title label="Edad"></app-fiel-title>
						<p class="readOnly">
							{{ examen.trabajador.edad }} años
						</p>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}"
							alfanumericoDirective formControlName="puestoTrabajador" id="puesto" name="puesto"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.puestoTrabajador.value}}
						</span>
						<app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso"
							class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-field p-col-12 p-md-4">
						<app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
							{{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
							[disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
							[minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
							(onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('antiguedadOtrosCargos')" class="p-col-12 p-md-12">
						<app-fiel-title label="Antiguedad en otros cargos con uso de la voz:" required="true">
						</app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton (onClick)="clickRadioButtonOtrosCargos()" [value]="true"
								formControlName="antiguedadOtrosCargos" label="Si" name="antiguedadOtrosCargos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.antiguedadOtrosCargos">
							</p-radioButton>
							<p-radioButton (onClick)="clickRadioButtonOtrosCargos()" [value]="false"
								formControlName="antiguedadOtrosCargos" label="No" name="antiguedadOtrosCargos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.antiguedadOtrosCargos">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.antiguedadOtrosCargos.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('antiguedadDescripcion')" class="p-col-12 p-md-6">
						<app-fiel-title label="Describa:"></app-fiel-title>
						<p [ngClass]="{'print_show-on-print': f.antiguedadDescripcion.value?.length > 0 && f.antiguedadOtrosCargos.value,
							'print_hide-on-print': f.antiguedadDescripcion.value?.length < 1}"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.antiguedadDescripcion.value}}
						</p>
						<textarea class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadDescripcion.invalid}" cols="30"
							formControlName="antiguedadDescripcion" id="result" maxlength="250" name="resul"
							pInputTextarea rows="5" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
						</textarea>
						<small style="text-align: end;">
							{{ f.antiguedadDescripcion.value.length }}/250
						</small>
						<app-invalid-from-message *ngIf="submitted && f.antiguedadDescripcion.errors?.required">
						</app-invalid-from-message>
						<app-invalid-from-message *ngIf="f.antiguedadDescripcion.errors?.maxlength"
							message="Solo se permiten {{ f.antiguedadDescripcion.errors.maxlength.requiredLength  }} caracteres">
						</app-invalid-from-message>
					</div>
				</div>
			</div>

			<div *ngIf="configForm.findSection('Actividad/Puesto')">
				<div class="p-grid p-mt-2">
					<span class="p-title-seccion">
						{{ configForm.findNumberSection("Actividad/Puesto") }}. Actividad / Puesto
					</span>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div *ngIf="configForm.findField('docente')" class="p-col-12 p-md-12">
						<app-fiel-title label="Docente:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="docente" label="Si" name="docente"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.docente"
								(onClick)="clickRadioButtonDocente()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="docente" label="No" name="docente"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.docente"
								(onClick)="clickRadioButtonDocente()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.docente.invalid"></app-invalid-from-message>
					</div>
					<div class="p-col-12 p-md-12 ">
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('titular')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="titular" inputId="ev" label="Titular" name="ev"
									[disabled]="examen?.modoVista === 'ver'" (onChange)="clicPuestoDocente($event, 'titular')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('provisorio')" class="p-field-checkbox" id="provisorio">
								<p-checkbox binary="true" formControlName="provisorio" inputId="ev" label="Provisorio" name="ev"
									[disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicPuestoDocente($event, 'provisorio')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('suplente')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="suplente" inputId="ev" label="Suplente" name="ev"
									[disabled]="examen?.modoVista === 'ver'" (onChange)="clicPuestoDocente($event, 'suplente')">
								</p-checkbox>
							</div>
						</div>
					</div>
					<div *ngIf="configForm.findField('cargaHorariaDiaria')"
						class="p-field p-col-12 p-md-3 p-field-without-border print_dont_break">
						<app-fiel-title label="Carga horaria diaria:" [required]="f.cargaHorariaDiaria.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.cargaHorariaDiaria.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.cargaHorariaDiaria.invalid}"
							numberDirective formControlName="cargaHorariaDiaria" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.cargaHorariaDiaria.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('cargaHorariaSemanal')"
						class="p-field p-col-12 p-md-3 p-field-without-border">
						<app-fiel-title label="Carga horaria semanal:" [required]="f.cargaHorariaSemanal.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.cargaHorariaSemanal.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.cargaHorariaSemanal.invalid}"
							numberDirective formControlName="cargaHorariaSemanal" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.cargaHorariaSemanal.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-col-12 p-md-12 print_dont_break">
						<app-fiel-title label="Nivel educativo:"></app-fiel-title>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('educacionPrePrimario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="educacionPrePrimario" inputId="educacionPrePrimario"
									label="Pre Primaria" name="ev" [disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoDocente($event, 'educacionPrePrimario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('educacionEnPrimario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="educacionEnPrimario" inputId="educacionEnPrimario"
									label="Primaria" name="ev" [disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoDocente($event, 'educacionEnPrimario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('educacionEnSecundario')" class="p-field-checkbox" id="secundaria">
								<p-checkbox binary="true" formControlName="educacionEnSecundario"
									inputId="educacionEnSecundario" label="Secundaria" name="ev"
									[disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoDocente($event, 'educacionEnSecundario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('educacionEnTerciario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="educacionEnTerciario" inputId="educacionEnTerciario"
									label="Terciario" name="ev" [disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoDocente($event, 'educacionEnTerciario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('educacionEnUniversitario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="educacionEnUniversitario"
									inputId="educacionEnUniversitario" label="Universitario" name="ev"
									[disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoDocente($event, 'educacionEnUniversitario')">
								</p-checkbox>
							</div>
						</div>
					</div>
					<div *ngIf="configForm.findField('cargaHorariaOtroEstablecimiento')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-12 print_row-full print_dont_break">
						<app-fiel-title label="Carga horaria en otro establecimiento:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="cargaHorariaOtroEstablecimiento" label="Si"
								name="cargaHorariaOtroEstablecimiento" [disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.cargaHorariaOtroEstablecimiento"
								(onClick)="clickRadioButtonCargaHorariaOtroEstablecimiento()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="cargaHorariaOtroEstablecimiento" label="No"
								name="cargaHorariaOtroEstablecimiento" [disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.cargaHorariaOtroEstablecimiento"
								(onClick)="clickRadioButtonCargaHorariaOtroEstablecimiento()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.cargaHorariaOtroEstablecimiento.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-col-12 p-md-12 print_dont_break">
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('otroEstablecimientoTitular')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="otroEstablecimientoTitular" inputId="ev" label="Titular" name="ev"
									[disabled]="examen?.modoVista === 'ver'" (onChange)="clicPuestoOtro($event, 'otroEstablecimientoTitular')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('otroEstablecimientoProvisorio')" class="p-field-checkbox" id="otroEstablecimientoProvisorio">
								<p-checkbox binary="true" formControlName="otroEstablecimientoProvisorio" inputId="ev" label="Provisorio" name="ev"
									[disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicPuestoOtro($event, 'otroEstablecimientoProvisorio')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('otroEstablecimientoSuplente')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="otroEstablecimientoSuplente" inputId="ev" label="Suplente" name="ev"
									[disabled]="examen?.modoVista === 'ver'" (onChange)="clicPuestoOtro($event, 'otroEstablecimientoSuplente')">
								</p-checkbox>
							</div>
						</div>
					</div>
					<div *ngIf="configForm.findField('otroEstabCargaHorariaDiaria')"
						class="p-field p-col-12 p-md-3 p-field-without-border">
						<app-fiel-title label="Carga horaria diaria:"
							[required]="f.otroEstabCargaHorariaDiaria.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.otroEstabCargaHorariaDiaria.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.otroEstabCargaHorariaDiaria.invalid}"
							numberDirective formControlName="otroEstabCargaHorariaDiaria" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.otroEstabCargaHorariaDiaria.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('otroEstabCargaHorariaSemanal')"
						class="p-field p-col-12 p-md-3 p-field-without-border">
						<app-fiel-title label="Carga horaria semanal:"
							[required]="f.otroEstabCargaHorariaSemanal.enabled"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.otroEstabCargaHorariaSemanal.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.otroEstabCargaHorariaSemanal.invalid}"
							numberDirective formControlName="otroEstabCargaHorariaSemanal" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.otroEstabCargaHorariaSemanal.invalid">
						</app-invalid-from-message>
					</div>
					<div class="p-col-12 p-md-12 ">
						<app-fiel-title label="Nivel educativo:"></app-fiel-title>
						<div class="p-field-checkbox-inline" style="display: flex; flex-direction: row;">
							<div *ngIf="configForm.findField('otroEstabEducacionPrePrimario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="otroEstabEducacionPrePrimario" inputId="otroEstabEducacionPrePrimario"
									label="Pre Primaria" name="ev" [disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoOtro($event, 'otroEstabEducacionPrePrimario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('otroEstabEducacionEnPrimario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="otroEstabEducacionEnPrimario" inputId="otroEstabEducacionEnPrimario"
									label="Primaria" name="ev" [disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoOtro($event, 'otroEstabEducacionEnPrimario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('otroEstabEducacionEnSecundario')" class="p-field-checkbox" id="secundaria">
								<p-checkbox binary="true" formControlName="otroEstabEducacionEnSecundario"
									inputId="otroEstabEducacionEnSecundario" label="Secundaria" name="ev"
									[disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoOtro($event, 'otroEstabEducacionEnSecundario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('otroEstabEducacionEnTerciario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="otroEstabEducacionEnTerciario" inputId="otroEstabEducacionEnTerciario"
									label="Terciario" name="ev" [disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoOtro($event, 'otroEstabEducacionEnTerciario')">
								</p-checkbox>
							</div>
							<div *ngIf="configForm.findField('otroEstabEducacionEnUniversitario')" class="p-field-checkbox">
								<p-checkbox binary="true" formControlName="otroEstabEducacionEnUniversitario"
									inputId="otroEstabEducacionEnUniversitario" label="Universitario" name="ev"
									[disabled]="examen?.modoVista === 'ver'"
									(onChange)="clicNivelEducativoOtro($event, 'otroEstabEducacionEnUniversitario')">
								</p-checkbox>
							</div>
						</div>
					</div>
					<!-- probar borrar todos los  -->
					<div *ngIf="configForm.findField('callCenter')" class="p-col-12 p-md-12">
						<app-fiel-title label="Call Center:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="callCenter" label="Si" name="callCenter"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.callCenter"
								(onClick)="clickRadioButtonCallCenter()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="callCenter" label="No" name="callCenter"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.callCenter"
								(onClick)="clickRadioButtonCallCenter()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.callCenter.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('callCenterCargaHorariaDiaria')"
						class="p-field p-col-12 p-md-3">
						<app-fiel-title label="Carga horaria diaria:"
							[required]="f.callCenterCargaHorariaDiaria.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.callCenterCargaHorariaDiaria.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.callCenterCargaHorariaDiaria.invalid}"
							numberDirective formControlName="callCenterCargaHorariaDiaria" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.callCenterCargaHorariaDiaria.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('callCenterCargaHorariaSemanal')"
						class="p-field p-col-12 p-md-3">
						<app-fiel-title label="Carga horaria semanal:"
							[required]="f.callCenterCargaHorariaSemanal.enabled"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.callCenterCargaHorariaSemanal.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.callCenterCargaHorariaSemanal.invalid}"
							numberDirective formControlName="callCenterCargaHorariaSemanal" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.callCenterCargaHorariaSemanal.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('callCenterDescripcion')" class="p-col-12 p-md-12">
						<app-fiel-title label="Breve descripción:" [required]="f.callCenterDescripcion.enabled">
						</app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.callCenterDescripcion.value?.length < 1,
						   'print_show-on-print': f.callCenterDescripcion.value?.length > 0 && f.callCenter.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.callCenterDescripcion.value }}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.callCenterDescripcion.invalid}"
							alphanumDirective formControlName="callCenterDescripcion" id="elprper" maxlength="250"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.callCenterDescripcion.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('otro')" class="p-col-12 p-md-12">
						<app-fiel-title label="Otro:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="otro" label="Si" name="otro"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.otro"
								(onClick)="clickRadioButtonOtro()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="otro" label="No" name="otro"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.otro"
								(onClick)="clickRadioButtonOtro()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.otro.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('otroCargaHorariaDiaria')" class="p-field p-col-12 p-md-3">
						<app-fiel-title label="Carga horaria diaria:" [required]="f.otroCargaHorariaDiaria.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.otroCargaHorariaDiaria.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.otroCargaHorariaDiaria.invalid}"
							numberDirective formControlName="otroCargaHorariaDiaria" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.otroCargaHorariaDiaria.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('otroCargaHorariaSemanal')" class="p-field p-col-12 p-md-3">
						<app-fiel-title label="Carga horaria semanal:" [required]="f.otroCargaHorariaSemanal.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.otroCargaHorariaSemanal.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.otroCargaHorariaSemanal.invalid}"
							numberDirective formControlName="otroCargaHorariaSemanal" id="elprper" maxlength="50"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.otroCargaHorariaSemanal.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('otroDescripcion')" class="p-col-12 p-md-12">
						<app-fiel-title label="Breve descripción:" [required]="f.otroDescripcion.enabled">
						</app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.otroDescripcion.value?.length < 1,
						   'print_show-on-print': f.otroDescripcion.value?.length > 0 && f.otro.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.otroDescripcion.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.otroDescripcion.invalid}" alphanumDirective
							formControlName="otroDescripcion" id="elprper" maxlength="250" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.otroDescripcion.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>
			<div *ngIf="configForm.findSection('TrabajadoresServiciosTelefonicos')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("TrabajadoresServiciosTelefonicos") }}. Trabajadores de
						Servicios Telefónicos
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div class="p-col-12 p-md-12 print_row-half" style="flex-wrap: nowrap; display: flex;">
						<div class="p-col-12 p-md-3">
							<div *ngIf="configForm.findField('monoaural') && configForm.findField('biaural')"
								class="p-col-12 p-md-12">
								<app-fiel-title label="Auriculares:"></app-fiel-title>
								<div style="display: flex; flex-direction: row;">
									<p-radioButton [value]="true" formControlName="biaural" label="Biaural" name="biaural"
										[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.biaural"
										(onClick)="clickRadioButtonAuricularesBiaural()">
									</p-radioButton>
									<p-radioButton [value]="true" formControlName="monoaural" label="Monoaural" name="monoaural"
										[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.monoaural"
										(onClick)="clickRadioButtonAuricularesMonoaural()">
									</p-radioButton>
								</div>
								<app-invalid-from-message *ngIf="submitted && f.biaural.invalid"></app-invalid-from-message>
							</div>
						</div>
						<div class="p-col-12 p-md-3">
							<div *ngIf="configForm.findField('reguladorVolumen')" class="p-col-12 p-md-12">
								<app-fiel-title label="Regulador de volumen:"
									[required]="examForm.controls.biaural.value || examForm.controls.monoaural.value">
								</app-fiel-title>
								<div style="display: flex; flex-direction: row;">
									<p-radioButton [value]="true" formControlName="reguladorVolumen" label="Si"
										name="reguladorVolumen" [disabled]="examen?.modoVista === 'ver'"
										[ngModel]="examen.reguladorVolumen">
									</p-radioButton>
									<p-radioButton [value]="false" formControlName="reguladorVolumen" label="No"
										name="reguladorVolumen" [disabled]="examen?.modoVista === 'ver'"
										[ngModel]="examen.reguladorVolumen">
									</p-radioButton>
								</div>
								<app-invalid-from-message *ngIf="submitted && f.reguladorVolumen.invalid">
								</app-invalid-from-message>
							</div>
						</div>
					</div>
					<div *ngIf="configForm.findField('servicioTelefonicoDescripcion')" class="p-col-12 p-md-12">
						<app-fiel-title label="Breve descripción de tareas:"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.servicioTelefonicoDescripcion.value?.length < 1,
						'print_show-on-print': f.servicioTelefonicoDescripcion.value?.length > 0 }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.servicioTelefonicoDescripcion.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.servicioTelefonicoDescripcion.invalid}"
							alphanumDirective formControlName="servicioTelefonicoDescripcion" id="elprper"
							maxlength="250" name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.servicioTelefonicoDescripcion.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>
			<div *ngIf="configForm.findSection('Habitos')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Habitos") }}. Hábitos
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div *ngIf="configForm.findField('tomaAlcohol')" class="p-col-12 p-md-12 print_dont_break">
						<app-fiel-title label="¿Toma alcohol?:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="tomaAlcohol" label="Si" name="tomaAlcohol"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.tomaAlcohol">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="tomaAlcohol" label="No" name="tomaAlcohol"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.tomaAlcohol">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.tomaAlcohol.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('fuma')" class="p-col-12 p-md-2 print_dont_break">
						<app-fiel-title label="¿Fuma?:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="fuma" label="Si" name="fuma"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.fuma"
								(onClick)="clickRadioButtonFuma()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="fuma" label="No" name="fuma"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.fuma"
								(onClick)="clickRadioButtonFuma()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.fuma.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('fumaCantidad')" class="p-field p-col-12 p-md-2 print_dont_break">
						<app-fiel-title label="Cantidad por día:" [required]="f.fumaCantidad.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.fumaCantidad.value}}
						</span>
						<input class="carga-horaria" [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.fumaCantidad.invalid}" numberDirective
							formControlName="fumaCantidad" id="elprper" maxlength="50" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.fumaCantidad.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('fumaDesde')" class="p-field p-col-12 p-md-3 print_dont_break">
						<app-fiel-title label="Fuma desde:" [required]="f.fumaDesde.enabled"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.fumaDesde.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="fumaDesde" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
							class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.fumaDesde.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.fumaDesde.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('tomaMedicacion')" class="p-col-12 p-md-12 print_dont_break">
						<app-fiel-title label="¿Toma medicación?:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="tomaMedicacion" label="Si"
								name="tomaMedicacion" [disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.tomaMedicacion" (onClick)="clickRadioButtonTomaMedicacion()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="tomaMedicacion" label="No"
								name="tomaMedicacion" [disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.tomaMedicacion" (onClick)="clickRadioButtonTomaMedicacion()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.tomaMedicacion.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('tomaMedicacionDetalle')" class="p-col-12 p-md-10 print_dont_break">
						<app-fiel-title label="Cual:" [required]="f.tomaMedicacionDetalle.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.tomaMedicacionDetalle.value?.length < 1,
						   'print_show-on-print': f.tomaMedicacionDetalle.value?.length > 0 && f.tomaMedicacion.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.tomaMedicacionDetalle.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.tomaMedicacionDetalle.invalid}"
							alphanumDirective formControlName="tomaMedicacionDetalle" id="elprper" maxlength="250"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.tomaMedicacionDetalle.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('realizaOtrasActividadesEsfuerzovoz')" class="p-col-12 p-md-12 print_dont_break">
						<app-fiel-title label="¿Realiza otras actividades con esfuerzo de voz?:" required="true">
						</app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="realizaOtrasActividadesEsfuerzovoz"
								label="Si" name="realizaOtrasActividadesEsfuerzovoz"
								[disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.realizaOtrasActividadesEsfuerzovoz"
								(onClick)="clickRadioButtonRealizaOtrasActividadesEsfuerzovoz()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="realizaOtrasActividadesEsfuerzovoz"
								label="No" name="realizaOtrasActividadesEsfuerzovoz"
								[disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.realizaOtrasActividadesEsfuerzovoz"
								(onClick)="clickRadioButtonRealizaOtrasActividadesEsfuerzovoz()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.realizaOtrasActividadesEsfuerzovoz.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('habitosDescripcion')" class="p-col-12 p-md-9 print_dont_break">
						<app-fiel-title label="Descripción:" [required]="f.habitosDescripcion.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.habitosDescripcion.value?.length < 1,
						   'print_show-on-print': f.habitosDescripcion.value?.length > 0 && f.realizaOtrasActividadesEsfuerzovoz.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.habitosDescripcion.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.habitosDescripcion.invalid}"
							alphanumDirective formControlName="habitosDescripcion" id="elprper" maxlength="250"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.habitosDescripcion.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>
			<div *ngIf="configForm.findSection('Antecedentes')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Antecedentes") }}. Antecedentes
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div *ngIf="configForm.findField('respiratorios')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Respiratorios:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="respiratorios" label="Si" name="respiratorios"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.respiratorios"
								(onClick)="clickRadioButtonRespiratorios()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="respiratorios" label="No" name="respiratorios"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.respiratorios"
								(onClick)="clickRadioButtonRespiratorios()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.respiratorios.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('respiratoriosDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.respiratoriosDesc.enabled">
						</app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.respiratoriosDesc.value?.length < 1,
									   'print_show-on-print': f.respiratoriosDesc.value?.length > 0 && f.respiratorios.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.respiratoriosDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.respiratoriosDesc.invalid}"
							alphanumDirective formControlName="respiratoriosDesc" id="elprper" maxlength="250" name="elprper"
							pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.respiratoriosDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('alergicos')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Alérgicos:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="alergicos" label="Si" name="alergicos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.alergicos"
								(onClick)="clickRadioButtonAlergicos()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="alergicos" label="No" name="alergicos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.alergicos"
								(onClick)="clickRadioButtonAlergicos()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.alergicos.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('alergicosDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.alergicosDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.alergicosDesc.value?.length < 1,
									   'print_show-on-print': f.alergicosDesc.value?.length > 0 && f.alergicos.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.alergicosDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.alergicosDesc.invalid}"
							alphanumDirective formControlName="alergicosDesc" id="elprper" maxlength="250" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.alergicosDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('quirurgicos')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Quirúrgicos:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="quirurgicos" label="Si" name="quirurgicos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.quirurgicos"
								(onClick)="clickRadioButtonQuirurgicos()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="quirurgicos" label="No" name="quirurgicos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.quirurgicos"
								(onClick)="clickRadioButtonQuirurgicos()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.quirurgicos.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('quirurgicosDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.quirurgicosDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.quirurgicosDesc.value?.length < 1,
									   'print_show-on-print': f.quirurgicosDesc.value?.length > 0 && f.quirurgicos.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.quirurgicosDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.quirurgicosDesc.invalid}"
							alphanumDirective formControlName="quirurgicosDesc" id="elprper" maxlength="250" name="elprper"
							pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.quirurgicosDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('digestivos')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Digestivos:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="digestivos" label="Si" name="digestivos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.digestivos"
								(onClick)="clickRadioButtonDigestivos()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="digestivos" label="No" name="digestivos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.digestivos"
								(onClick)="clickRadioButtonDigestivos()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.digestivos.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('digestivosDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.digestivosDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.digestivosDesc.value?.length < 1,
									   'print_show-on-print': f.digestivosDesc.value?.length > 0 && f.digestivos.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.digestivosDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.digestivosDesc.invalid}"
							alphanumDirective formControlName="digestivosDesc" id="elprper" maxlength="250" name="elprper"
							pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.digestivosDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('herniaHiatal')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Hernia Hiatal:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="herniaHiatal" label="Si" name="herniaHiatal"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.herniaHiatal"
								(onClick)="clickRadioButtonHerniaHiatal()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="herniaHiatal" label="No" name="herniaHiatal"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.herniaHiatal"
								(onClick)="clickRadioButtonHerniaHiatal()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.herniaHiatal.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('herniaHiatalDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.herniaHiatalDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.herniaHiatalDesc.value?.length < 1,
									   'print_show-on-print': f.herniaHiatalDesc.value?.length > 0 && f.herniaHiatal.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.herniaHiatalDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.herniaHiatalDesc.invalid}"
							alphanumDirective formControlName="herniaHiatalDesc" id="elprper" maxlength="250" name="elprper"
							pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.herniaHiatalDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('reflujoGastroesofagico')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Reflujo Gastroesofágico:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="reflujoGastroesofagico" label="Si"
								name="reflujoGastroesofagico" [disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.reflujoGastroesofagico" (onClick)="clickRadioButtonReflujoGastroesofagico()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="reflujoGastroesofagico" label="No"
								name="reflujoGastroesofagico" [disabled]="examen?.modoVista === 'ver'"
								[ngModel]="examen.reflujoGastroesofagico" (onClick)="clickRadioButtonReflujoGastroesofagico()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.reflujoGastroesofagico.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('reflujoGastroesofagicoDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.reflujoGastroesofagicoDesc.enabled">
						</app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.reflujoGastroesofagicoDesc.value?.length < 1,
									   'print_show-on-print': f.reflujoGastroesofagicoDesc.value?.length > 0 && f.reflujoGastroesofagico.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.reflujoGastroesofagicoDesc.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.reflujoGastroesofagicoDesc.invalid}" alphanumDirective
							formControlName="reflujoGastroesofagicoDesc" id="elprper" maxlength="250" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.reflujoGastroesofagicoDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('tiroideos')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full print_dont_break">
						<app-fiel-title label="Tiroideos:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="tiroideos" label="Si" name="tiroideos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.tiroideos"
								(onClick)="clickRadioButtonTiroideos()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="tiroideos" label="No" name="tiroideos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.tiroideos"
								(onClick)="clickRadioButtonTiroideos()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.tiroideos.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('tiroideosDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.tiroideosDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.tiroideosDesc.value?.length < 1,
									   'print_show-on-print': f.tiroideosDesc.value?.length > 0 && f.tiroideos.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.tiroideosDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.tiroideosDesc.invalid}"
							alphanumDirective formControlName="tiroideosDesc" id="elprper" maxlength="250" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.tiroideosDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('laringitisCronica')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full">
						<app-fiel-title label="Laringitis Crónica:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="laringitisCronica" label="Si" name="laringitisCronica"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.laringitisCronica"
								(onClick)="clickRadioButtonLaringitisCronica()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="laringitisCronica" label="No" name="laringitisCronica"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.laringitisCronica"
								(onClick)="clickRadioButtonLaringitisCronica()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.laringitisCronica.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('laringitisCronicaDesde')"
						class="p-field p-field-without-border p-col-12 p-md-3">
						<app-fiel-title label="Laringitis Crónica desde:" [required]="f.laringitisCronicaDesde.enabled">
						</app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.laringitisCronicaDesde.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="laringitisCronicaDesde" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
							class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.laringitisCronicaDesde.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.laringitisCronicaDesde.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('laringitisCronicaDesde')"
						class="p-col-12 p-md-6">
					</div>
					<div *ngIf="configForm.findField('poliposFaringeos')"
						class="p-field p-field-print p-col-12 p-md-3 p-field-without-border">
						<app-fiel-title label="Pólipos Laríngeos:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="poliposFaringeos" label="Si" name="poliposFaringeos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.poliposFaringeos"
								(onClick)="clickRadioButtonPolipos()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="poliposFaringeos" label="No" name="poliposFaringeos"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.poliposFaringeos"
								(onClick)="clickRadioButtonPolipos()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.poliposFaringeos.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('poliposLaringeosDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.poliposLaringeosDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.poliposLaringeosDesc.value?.length < 1,
									   'print_show-on-print': f.poliposLaringeosDesc.value?.length > 0 && f.poliposFaringeos.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.poliposLaringeosDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.poliposLaringeosDesc.invalid}"
							alphanumDirective formControlName="poliposLaringeosDesc" id="poliposLaringeosDesc" maxlength="250" name="poliposLaringeosDesc" 
							pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.poliposLaringeosDesc.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('nodulosVocales')"
						class="p-field p-field-print p-col-12 p-md-3 p-field-without-border">
						<app-fiel-title label="Nódulos Vocales:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="nodulosVocales" label="Si" name="nodulosVocales"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.nodulosVocales"
								(onClick)="clickRadioButtonNodulos()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="nodulosVocales" label="No" name="nodulosVocales"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.nodulosVocales"
								(onClick)="clickRadioButtonNodulos()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.nodulosVocales.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('nodulosVocalesDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-9 print_row-full print_dont_break">
						<app-fiel-title label="Observaciones:" [required]="f.nodulosVocalesDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.nodulosVocalesDesc.value?.length < 1,
									   'print_show-on-print': f.nodulosVocalesDesc.value?.length > 0 && f.nodulosVocales.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.nodulosVocalesDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.nodulosVocalesDesc.invalid}"
							alphanumDirective formControlName="nodulosVocalesDesc" id="nodulosVocalesDesc" maxlength="250" name="nodulosVocalesDesc" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.nodulosVocalesDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('disfonia')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-3 print_row-full">
						<app-fiel-title label="Disfonía Funcional:" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;">
							<p-radioButton [value]="true" formControlName="disfonia" label="Si" name="disfonia"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.disfonia"
								(onClick)="clickRadioButtonDisfonia()">
							</p-radioButton>
							<p-radioButton [value]="false" formControlName="disfonia" label="No" name="disfonia"
								[disabled]="examen?.modoVista === 'ver'" [ngModel]="examen.disfonia"
								(onClick)="clickRadioButtonDisfonia()">
							</p-radioButton>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.disfonia.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('disfoniaDesde')" class="p-field p-field-without-border p-col-12 p-md-3">
						<app-fiel-title label="Disfonía desde:" [required]="f.disfoniaDesde.enabled"></app-fiel-title>
						<span class="print_edadInputNumber_hide print_hide print_show-on-print print_filled_input">
							{{examForm.controls.disfoniaDesde.value | date: "dd/MM/yyyy"}}
						</span>
						<p-calendar formControlName="disfoniaDesde" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
							placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
							class="print_hide-on-print" [ngClass]="{'ng-invalid ng-dirty': submitted && f.disfoniaDesde.invalid}"
							[disabled]="examen?.modoVista === 'ver'">
						</p-calendar>
						<app-invalid-from-message *ngIf="submitted && f.disfoniaDesde.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('disfoniaDesc')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-12 print_row-full"
						style="margin-bottom: 20px !important;">
						<app-fiel-title label="Observaciones:" [required]="f.disfoniaDesc.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.disfoniaDesc.value?.length < 1,
									   'print_show-on-print': f.disfoniaDesc.value?.length > 0 && f.disfonia.value }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.disfoniaDesc.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.disfoniaDesc.invalid}"
							alphanumDirective formControlName="disfoniaDesc" id="elprper" maxlength="250" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.disfoniaDesc.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('antecedentesOtras')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-12 print_row-full"
						style="margin-bottom: 20px !important;">
						<app-fiel-title label="Otras:" required="true"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.antecedentesOtras.value?.length < 1,
									   'print_show-on-print': f.antecedentesOtras.value?.length > 0}"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.antecedentesOtras.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.antecedentesOtras.invalid}"
							alphanumDirective formControlName="antecedentesOtras" id="antecedentesOtras" maxlength="250" name="antecedentesOtras" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.antecedentesOtras.invalid"></app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('caractSubjetivasVoz')"
						class="p-field p-field-print p-field-without-border p-col-12 p-md-12 print_row-full"
						style="margin-bottom: 20px !important;">
						<app-fiel-title label="Características subjetivas de la voz:" required="true"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.caractSubjetivasVoz.value?.length < 1,
									   'print_show-on-print': f.caractSubjetivasVoz.value?.length > 0 }"
							class="print_hidden-area-before-print print_row-full p-field-word-break">
							{{examForm.controls.caractSubjetivasVoz.value}}
						</p>
						<input [disabled]="true" [ngClass]="{'ng-invalid ng-dirty':submitted && f.caractSubjetivasVoz.invalid}"
							alphanumDirective formControlName="caractSubjetivasVoz" id="caractSubjetivasVoz" maxlength="250" name="caractSubjetivasVoz" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.caractSubjetivasVoz.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>
			<div *ngIf="configForm.findSection('Laringoscopia Indirecta')">
				<div class="p-grid p-mt-2">
					<label class="p-title-seccion">
						{{ configForm.findNumberSection("Laringoscopia Indirecta") }}. Laringoscopía Indirecta (completar en caso de disfonía)
					</label>
				</div>
				<p-divider></p-divider>
				<div class="p-grid p-grid-space">
					<div *ngIf="configForm.findField('aspectoAnatomicoLaringe')"
						class="p-field p-field-print p-col-12 p-md-12 print_row-full p-field-without-border print_dont_break">
						<app-fiel-title label="Aspecto Anatómico de la Laringe:"
							[required]="f.aspectoAnatomicoLaringe.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.aspectoAnatomicoLaringe.value?.length < 1,
						   'print_show-on-print': f.aspectoAnatomicoLaringe.value?.length > 0 && f.disfonia.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.aspectoAnatomicoLaringe.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.aspectoAnatomicoLaringe.invalid}"
							alphanumDirective formControlName="aspectoAnatomicoLaringe" id="elprper" maxlength="250"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.aspectoAnatomicoLaringe.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('observaciones')"
						class="p-field p-field-print p-col-12 p-md-12 print_row-full p-field-without-border print_dont_break"
						style="margin-bottom: 20px !important;">
						<app-fiel-title label="Observaciones:" [required]="f.observaciones.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.observaciones.value?.length < 1,
						   'print_show-on-print': f.observaciones.value?.length > 0 && f.disfonia.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.observaciones.value}}
						</p>
						<input [disabled]="true"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.observaciones.invalid}" alphanumDirective
							formControlName="observaciones" id="elprper" maxlength="250" name="elprper" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.observaciones.invalid">
						</app-invalid-from-message>
					</div>
					<div *ngIf="configForm.findField('diagnosticoSugerencias')"
						class="p-field p-field-print p-col-12 p-md-12 print_row-full p-field-without-border print_dont_break"
						style="margin-bottom: 20px !important;">
						<app-fiel-title label="Diagnóstico y sugerencias:"
							[required]="f.diagnosticoSugerencias.enabled"></app-fiel-title>
						<p [ngClass]="{'print_hide-on-print': f.diagnosticoSugerencias.value?.length < 1,
						   'print_show-on-print': f.diagnosticoSugerencias.value?.length > 0 && f.disfonia.value }"
						   class="print_hidden-area-before-print print_row-full p-field-word-break">
						   {{examForm.controls.diagnosticoSugerencias.value}}
						</p>
						<input [disabled]="true" class="print_hide-on-print"
							[ngClass]="{'ng-invalid ng-dirty':submitted && f.diagnosticoSugerencias.invalid}"
							alphanumDirective formControlName="diagnosticoSugerencias" id="elprper" maxlength="250"
							name="elprper" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.diagnosticoSugerencias.invalid">
						</app-invalid-from-message>
					</div>
				</div>
			</div>
			<div class="p-col-6 p-md-6 print_show-on-print p_hidden">
        <div class="img_svg">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 424.26 337.5" style="enable-background:new 0 0 424.26 337.5;" xml:space="preserve">
          <style type="text/css">
            .st00{fill:#FEFDFD;}
            .st10{fill:#FA9896;}
            .st20{fill:#D14353;}
            .st30{fill:#E66776;}
            .st40{fill:#F2ADB7;}
            .st50{fill:#DDF0F1;}
          </style>
          <g>
            <g>
              <path class="st00" d="M208.72,4.51c66.45,0,132.89,0.03,199.34-0.1c3.4-0.01,4.09,0.66,4.09,4.08
                c-0.12,104.91-0.11,209.81-0.02,314.72c0,3.16-0.3,4.21-3.95,4.21c-133.06-0.13-266.12-0.12-399.18-0.03
                c-3.1,0-3.82-0.69-3.82-3.81C5.27,218.5,5.28,113.43,5.15,8.36c0-3.69,1.11-3.93,4.23-3.92C75.83,4.53,142.27,4.51,208.72,4.51z
                M216.67,306.52c17.92-0.27,35.53-2.99,52.9-7.21c27.28-6.62,52.14-18.05,72.48-37.87c19.88-19.37,30.25-43.47,32.97-70.73
                c1.15-11.51,0.24-23.23,0.27-34.86c-0.01-6.44-1.04-12.72-2.97-18.85c-0.45-2.27-0.73-4.58-1.36-6.8
                c-10.52-36.83-33.97-62.78-67.72-79.92c-25.69-13.05-53.24-19.15-81.81-21.15c-37.39-2.61-74.02,0.7-109.37,14.09
                C87.82,52.41,66.84,66.22,50.6,86.61C38.74,101.49,30.53,118.15,27.1,137c-2.03,5.79-2.82,11.78-2.97,17.88
                c-1.63,11.73-1.22,23.45,0.02,35.18c3.82,36.14,20.19,65.11,50.42,85.46c32.58,21.93,69.54,29.55,108.14,30.97
                C194.03,307.74,205.35,307.7,216.67,306.52z"/>
              <path class="st10" d="M372.31,137c1.93,6.14,2.96,12.41,2.97,18.85c-8.59-1.71-17.38-2.32-25.79-4.98
                c-7.42-2.35-7.45-2.29-12.19,4.07c-15.07,20.22-25.61,42.77-34.3,66.29c-5.69,15.4-12.34,30.27-23.03,43.01
                c-11,13.12-24.1,21.54-42.08,20.23c-9.42-0.69-17.97-5.37-27.46-5.61c-11.36-0.29-22.81-2.2-33.94,1.79
                c-5.16,1.85-10.38,3.35-15.89,3.75c-18.54,1.34-31.66-8.12-42.4-21.69c-11.26-14.22-18.05-30.77-24.27-47.67
                c-8.33-22.65-19.38-43.95-33.5-63.61c-1.64-2.29-3.16-2.84-5.84-1.93c-9.86,3.34-20.16,4.38-30.46,5.36
                c0.15-6.1,0.94-12.1,2.97-17.88c4.91-0.96,9.74-2.29,13.97-5.01c10.59-6.82,20.25-14.69,27.99-24.77
                c9.04-11.78,16.6-24.66,28.5-34.23c15.7-12.63,33.62-18.66,53.33-18.27c12.28,0.24,24.49,3.25,36.84,4.07
                c12.44,0.83,24.89,0.76,37.16-1.24c12.79-2.09,25.44-3.7,38.42-1.82c24.66,3.58,42.23,18.1,56.54,37.03
                c9.1,12.03,17.53,24.44,29.94,33.48C356.65,131.24,363.64,135.84,372.31,137z M214.78,103.28c-9.45,1.81-19.01,0.49-28.5,0.88
                c-4.33-2.86-9.63-2.92-14.25-4.93c-7.13-3.16-14.87-3.19-22.01-1.73c-16.15,3.3-30.39,11.03-42.91,21.83
                c-10.03,8.66-20.67,16.46-32.79,21.99c-3.1,1.42-3.84,2.52-0.73,5c2.42,1.93,4.11,4.74,6.29,6.98
                c14.96,15.38,27.46,32.63,38.64,50.85c7.81,12.74,16.87,24.39,27.95,34.44c7.89,6.53,15.18,13.83,24.24,18.86
                c1.13,1.58,3.01,1.95,4.57,2.83c4.55,2.58,8.73,3.28,14.42,1.88c6.19-1.52,13.41-3.14,19.87-0.41c7.86,3.33,13.48-0.47,19.2-4.74
                c9.87-4.98,18.2-11.84,25.17-20.39c9.62-7.24,16.86-16.6,23.37-26.56c6.23-9.53,11.69-19.64,18.58-28.66
                c9.21-12.08,18.69-24.04,29.87-34.47c2.75-2.56,2.61-4.2-1.11-5.97c-9.89-4.72-19.3-10.47-27.4-17.81
                c-14.95-13.54-32.16-22.09-52.07-24.77c-5.23-0.7-10.86-1.58-16.07,0.97C224.14,99.99,219.19,100.66,214.78,103.28z"/>
              <path class="st20" d="M24.13,154.88c10.29-0.99,20.6-2.02,30.46-5.36c2.67-0.91,4.19-0.36,5.84,1.93
                c14.12,19.66,25.17,40.97,33.5,63.61c6.22,16.9,13.01,33.45,24.27,47.67c10.74,13.57,23.87,23.03,42.4,21.69
                c5.51-0.4,10.73-1.9,15.89-3.75c11.13-3.99,22.58-2.08,33.94-1.79c9.49,0.24,18.04,4.92,27.46,5.61
                c17.98,1.32,31.08-7.11,42.08-20.23c10.69-12.75,17.34-27.62,23.03-43.01c8.69-23.52,19.23-46.07,34.3-66.29
                c4.74-6.36,4.77-6.42,12.19-4.07c8.41,2.66,17.2,3.27,25.79,4.98c-0.03,11.63,0.88,23.34-0.27,34.86
                c-2.72,27.26-13.1,51.36-32.97,70.73c-20.34,19.82-45.2,31.25-72.48,37.87c-17.37,4.22-34.98,6.93-52.9,7.21
                c-1.29-1.48-3.04-0.99-4.63-1c-8.23-0.04-16.45-0.04-24.68,0c-1.59,0.01-3.33-0.47-4.65,0.97c-38.6-1.42-75.56-9.03-108.14-30.97
                c-30.23-20.35-46.6-49.32-50.42-85.46C22.91,178.33,22.5,166.61,24.13,154.88z"/>
              <path class="st20" d="M372.31,137c-8.67-1.16-15.66-5.77-22.53-10.77c-12.41-9.03-20.84-21.44-29.94-33.48
                c-14.31-18.93-31.88-33.45-56.54-37.03c-12.98-1.88-25.63-0.26-38.42,1.82c-12.27,2-24.71,2.07-37.16,1.24
                c-12.36-0.83-24.56-3.83-36.84-4.07c-19.7-0.39-37.63,5.64-53.33,18.27c-11.9,9.57-19.46,22.46-28.5,34.23
                c-7.74,10.08-17.41,17.95-27.99,24.77c-4.22,2.72-9.05,4.05-13.97,5.01c3.43-18.84,11.64-35.51,23.49-50.39
                c16.25-20.39,37.22-34.2,61.46-43.38c35.34-13.39,71.98-16.7,109.37-14.09c28.57,2,56.12,8.09,81.81,21.15
                c33.74,17.15,57.2,43.1,67.72,79.92C371.59,132.42,371.87,134.73,372.31,137z"/>
              <path class="st30" d="M182.71,306.49c1.31-1.44,3.06-0.96,4.65-0.97c8.23-0.04,16.45-0.04,24.68,0c1.59,0.01,3.34-0.48,4.63,1
                C205.35,307.7,194.03,307.74,182.71,306.49z"/>
              <path class="st30" d="M146.47,238.62c-11.08-10.05-20.14-21.71-27.95-34.45c-11.18-18.22-23.68-35.47-38.64-50.85
                c-2.19-2.25-3.88-5.06-6.29-6.98c-3.11-2.48-2.38-3.59,0.73-5c12.13-5.53,22.76-13.33,32.79-21.99
                c12.52-10.81,26.76-18.53,42.91-21.83c7.14-1.46,14.88-1.43,22.01,1.73c-0.38,1.08-0.91,2.12-1.11,3.23
                c-4.32,23.74-8.62,47.49-12.88,71.24C154.15,195.33,150.32,216.98,146.47,238.62z"/>
              <path class="st30" d="M229.1,99.37c5.21-2.55,10.84-1.67,16.07-0.97c19.91,2.69,37.12,11.23,52.07,24.77
                c8.1,7.34,17.51,13.09,27.4,17.81c3.71,1.77,3.85,3.41,1.11,5.97c-11.18,10.43-20.66,22.39-29.87,34.47
                c-6.88,9.03-12.34,19.13-18.58,28.66c-6.51,9.96-13.74,19.32-23.37,26.56c-3.19-17.53-6.4-35.05-9.55-52.59
                c-1.98-11.02-3.84-22.05-5.76-33.08c2-7.6-1.2-14.43-3.18-21.44c-1.55-0.64-1.35-2.21-1.57-3.38
                C232.21,117.24,230.67,108.3,229.1,99.37z"/>
              <path class="st40" d="M186.27,104.16c9.5-0.39,19.05,0.93,28.5-0.88c0,2.48-0.16,4.98,0.02,7.45c0.87,11.83,2.61,23.57,3.1,35.47
                c0.29,7.17,1.41,14.36,1.95,21.57c0.66,8.82,1.95,17.59,2.83,26.4c0.79,7.84,0.83,15.8,2.21,23.52
                c2.34,13.04,3.22,26.17,3.87,39.35c-5.73,4.27-11.34,8.07-19.2,4.74c-6.47-2.74-13.68-1.12-19.87,0.41
                c-5.68,1.4-9.87,0.69-14.42-1.88c-1.56-0.88-3.44-1.26-4.57-2.83c1.81-13.74,2.92-27.54,4.21-41.33
                c1.03-10.99,1.74-22.04,3.09-32.97c2.2-17.8,3.34-35.7,5.63-53.49C184.74,121.2,185.41,112.67,186.27,104.16z"/>
              <path class="st50" d="M228.76,257.04c-0.65-13.18-1.53-26.31-3.87-39.35c-1.38-7.72-1.43-15.68-2.21-23.52
                c-0.89-8.81-2.17-17.58-2.83-26.4c-0.54-7.21-1.65-14.4-1.95-21.57c-0.49-11.9-2.23-23.64-3.1-35.47
                c-0.18-2.47-0.03-4.97-0.02-7.45c4.42-2.62,9.36-3.28,14.32-3.91c1.57,8.93,3.11,17.87,4.78,26.79c0.22,1.17,0.02,2.74,1.57,3.38
                c-0.13,7.33,1.9,14.33,3.18,21.44c1.92,11.03,3.78,22.06,5.76,33.08c3.14,17.54,6.36,35.06,9.55,52.59
                C246.96,245.19,238.63,252.06,228.76,257.04z"/>
              <path class="st50" d="M186.27,104.16c-0.86,8.51-1.54,17.04-2.63,25.52c-2.3,17.79-3.44,35.69-5.63,53.49
                c-1.35,10.93-2.06,21.98-3.09,32.97c-1.29,13.79-2.4,27.6-4.21,41.33c-9.06-5.03-16.35-12.32-24.24-18.86
                c3.85-21.64,7.68-43.28,11.56-64.92c4.26-23.75,8.56-47.5,12.88-71.24c0.2-1.11,0.73-2.16,1.11-3.23
                C176.64,101.24,181.94,101.3,186.27,104.16z"/>
              <path class="st20" d="M238.63,150.98c-1.28-7.11-3.32-14.12-3.18-21.44C237.43,136.54,240.63,143.38,238.63,150.98z"/>
            </g>
          </g>
          </svg>
        </div>
			</div>
			<div class="print_hide-on-print" *ngIf="configForm.findSection('Dictamen medico')">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Dictamen medico") }}.Dictamen médico
				</label>
				<p-divider></p-divider>

				<div class="p-grid">

					<div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
						<div style="display: flex; flex-direction: row;"
							[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

							<div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

								<p-radioButton name="codigoDictamen" [value]="item.codigo"
									formControlName="codigoDictamen" label="{{ item.descripcion }}"
									[ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
									[disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
								</p-radioButton>

							</div>
						</div>
						<app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid">
						</app-invalid-from-message>
					</div>


					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Especialidad" required="true"></app-fiel-title>
						<p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
							[options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
							optionLabel="descripcion" optionValue="codigo" [showClear]="true"
							[disabled]="examen?.modoVista === 'ver'">
						</p-dropdown>
						<app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid">
						</app-invalid-from-message>
					</div>


					<div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Médico" required="true"></app-fiel-title>
						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}"
							alfanumericoDirective formControlName="medicoNombre" id="medico" name="medico"
							maxlength="100" pInputText type="text"
							[attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid">
						</app-invalid-from-message>
					</div>


					<div class="p-field p-col-12 p-md-6">
						<app-fiel-title label="Matrícula" required="true"></app-fiel-title>

						<input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoMatricula.invalid}" numberDirective
							formControlName="medicoMatricula" id="medicoMatricula" name="medicoMatricula" maxlength="18" pInputText
							type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
						<app-invalid-from-message *ngIf="submitted && f.medicoMatricula.invalid"></app-invalid-from-message>
					</div>
				</div>
				<div class="p-grid p-form-footer">
					<div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
						<button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button"
							label="Firmar" (click)="showModalFirma()"></button>
					</div>
					<div class="p-field p-col-12 p-md-12">
						<app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
					</div>
				</div>
			</div>


			<div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
				<label class="p-title-seccion">
					{{ configForm.findNumberSection("Adjuntos") }}.Archivos adjuntos
					<strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
					<span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
						{{ attachedFiles.attachedFilesValidQuantity }}
					</span>
				</label>
				<p-divider></p-divider>

				<app-attach-upload-file [examenNumero]="this.examen?.id" [isRequire]="configForm.isAttachedFileRequire"
					(filesAttachedData)="getAttachedFiles($event)" [attachedFilesFromBackend]="this.examen?.attachments"
					[viewMode]="this.examen?.modoVista" [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
				</app-attach-upload-file>

				<app-attached-file-mandatory-message
					*ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
				</app-attached-file-mandatory-message>
			</div>

			<div class="p-grid p-form-footer">
				<div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
					<ng-container *ngIf="examen?.modoVista === 'ver'">
						<button pButton pRipple type="button" label="Volver" class="p-button-text"
							(click)="goBack()"></button>
					</ng-container>

					<ng-container *ngIf="examen?.modoVista !== 'ver'">
						<button pButton pRipple type="button" label="Cancelar" class="p-button-text"
							(click)="goBack()"></button>
						<p-button type="submit" label="Guardar" *ngIf="!enviandose"
							[disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
						</p-button>
						<p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
					</ng-container>
				</div>
			</div>

			<app-print-footer [firmaB64]="examen?.firmaB64"
                        [medicoFirmaB64]="medicoFirmaB64"
                        [trabajadorApellidoNombre]="f.apellidoNombre.value"
                        [medicoNombre]="f.medicoNombre?.value"
                        [medicoEspecialidad]="f.medicoEspecialidad.value"
                        [medicoMatricula]="f.medicoMatricula?.value">
      </app-print-footer>

		</div>
	</form>

	<p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormEC"
		styleClass="p-dialog-custom">
		<p-footer>
			<button (click)="cd.reject()" class="p-button-text" label="No, volver al examen" pButton
				type="button"></button>
			<button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
		</p-footer>

	</p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma"
		(closeModal)="closeModalFirma()"></app-topaz>
</section>
